import cheader from '@/components/header/index.vue'
import Unmatcheds from '../duima/index.vue'
export default {
  name: 'inquiry_create',
  data() {
    let phoneVerify = (rule, value, callback) => {
      const reg = /^1[3|4|5|7|8|9][0-9]\d{8}$/
      if (reg.test(value)) {
        callback()
      } else {
        return callback(new Error('请输入正确的手机号'))
      }
    }
    return {
      picker: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7
        },
      },
      submitAble: true,
      changeStatus:'无',
      purchaseDialogShow:false,
      purchaseList:[],//选择采购单时table列表
      purchaseTotal:0,
      form: {
        userId: this.$store.state.user.id,
        source: this.$route.params.source,
        name: '',
        cutoff: {
          type: '',
          value: ''
        },
        purchase:[],
        goods: [],
        noMatchProductList:[],
        aimType: '',
        aims: [],
        isTicket: '',
        pay: '',
        contact: '',
        phone: '',
        address: '',
        remark: ''
      },
      open:false,
      goodsInfo:[],
      rules: {
        name: {
          required: true,
          message: '请输入用户名',
          trigger: 'blur'
        },
        cutoff: {
          type: {
            required: true,
            message: '请选择截止条件',
            trigger: 'change'
          },
          value: {
            required: true,
            message: '请输入该选项',
            trigger: 'blur'
          }
        },
        aimType: {
          required: true,
          message: '请选择目标公开类型',
          trigger: 'change'
        },
        aims: {
          required: true,
          validator(rule, value, callback) {
            if (value.length == 0) {
              return callback(new Error('请选择目标供应商'))
            } else {
              callback()
            }
          },
          trigger: 'change'
        },
        isTicket: {
          required: true,
          message: '请选择是否含有发票',
          trigger: 'change'
        },
        pay: {
          required: true,
          message: '请选择付款方式',
          trigger: 'change'
        },
        contact: {
          required: true,
          message: '请输入联系人',
          trigger: 'blur'
        },
        phone: {
          required: true,
          validator: phoneVerify,
          trigger: 'blur'
        },
        address: {
          required: true,
          message: '请输入送货地址',
          trigger: 'blur'
        }
      },
      goodsDialogShow: false,
      unmatchedCodeShow:false,
      search: {
        good: {
          cate: [],
          name: ''
        },
        purchase:{
          name:''
        },
        offer: {
          name: ''
        }
      },
      brands: [],
      presclass: [],
      cates: [],
      goods: [],
      goodTotal: 0,
      offerTotal: 0,
      goodCur: 1,
      purchaseCur:1,
      offerCur: 1,
      offersDialogShow: false,
      offers: [],
      goodCreateVisable: false,
      errorExpected: '',
      form1: {
        name: '',
        brand: '',
        cates: [],
        code: '',
        numbering: '',
        recnumber: '',
        manufacturer: '',
        specification: '',
        presclass: '',
        formulation: '',
        prounit: '',
        erp: '',
        images: []
      },
      curpage2: 1,
      rules1: {
        name: {
          required: true,
          message: '请输入产品名称',
          trigger: 'blur'
        },
        brand: {
          required: true,
          message: '请选择品牌',
          trigger: 'change'
        },
        cates: {
          required: true,
          message: '请选择产品分类',
          trigger: 'change'
        },
        code: {
          required: true,
          message: '请输入助记码',
          trigger: 'blur'
        },
        numbering: {
          required: true,
          message: '请输入产品编码',
          trigger: 'blur'
        },
        recnumber: {
          required: true,
          message: '请输入批准文号',
          trigger: 'blur'
        },
        manufacturer: {
          required: true,
          message: '请输入生产厂家',
          trigger: 'blur'
        },
        specification: {
          required: true,
          message: '请输入产品规格',
          trigger: 'blur'
        },
        presclass: {
          required: true,
          message: '请选择处方分类',
          trigger: 'change'
        },
        formulation: {
          required: true,
          message: '请输入剂型',
          trigger: 'blur'
        },
        prounit: {
          required: true,
          message: '请输入产品单位',
          trigger: 'blur'
        },
        erp: {
          required: true,
          message: '请输入erp编码',
          trigger: 'blur'
        },
        bagShl: {
          required: true,
          message: '请输入件包装(只能输入数字)',
          trigger: 'blur'
        }
      },
      total2:0,
      dialogResultVisible: false,
      nowData:{},
      mergeFlag:"",
      tempList:[],
      emptyText: '加载中...'
    }
  },
  computed: {
    user() {
      return this.$store.state.user
    },
    expectedAble() {
      for (let item of this.form.goods) {
        if (item.expected == 0) {
          this.errorExpected = 'expected' + item.id
          return false
        }
      }
      return true
    }
  },
  watch: {
    'form.cutoff.type'() {
      this.form.cutoff.value = ''
    }
  },
  components: {
    cheader,
    Unmatcheds
  },
  created() {
    this.contactInit()
    this.supplierCount()
    this.cateIndex()
    this.brandIndex()
    this.presclassIndex()
    this.goodInit()
    this.orderSwitch()
  },
  methods: {
    async goInfo(page,item) {
      this.page2 = page
      this.curpage2 = page
      this.open=true
      this.nowData = item
      this.nextGoods(page)
    },
    nextGoods(page){
        this.open = true
        this.page2 = page
        var item = this.nowData
        var params = {
            userId: this.user.id,
            companyId:this.user.customerId,
            pid:item.pid,
            page: page,
            pageSize:10
        }
        this.$http.get('/api/ucenter/pur/purOrder/item/list',{params:params}).then((res) => {
            if(res.data.success){
                this.goodsInfo = res.data.data
                this.total2 = res.data.total
            }
        })
    },
    orderSwitch() {
      if (this.user.id) {
        this.$http.get('/api/user/orderSwitch', {params: {comId: this.user.customerId}}).then((res) => {
          this.mergeFlag = res.data.message
        })
      }
    },
    go(url) {
      this.$router.push(url)
    },
    cateChange(val) {
    },
    /*-- 获取用户联系方式 --*/
    contactInit() {
      this.$http.get("/api/inquiry/getLatestContact", { params: { userId: this.user.id } }).then((res) => {
         if(res.data.success){
          this.form.contact = res.data.data.contact
          this.form.phone = res.data.data.phone
          this.form.address = res.data.data.address
         }else{
          this.form.contact = this.user.name
          this.form.phone = this.user.phone
         }
        
      })
    },
    /*-- 获取用户的供应商数量 --*/
    supplierCount() {
      this.$http.get('/api/inquiry/supplier', {
        params: {
          userId: this.user.id,
          name: this.search.offer.name,
          page: 1,
          pageSize: 10
        }
      }).then((res) => {
        this.offerTotal = res.data.total
      })
    },
    /*-- 获取产品分类 --*/
    cateIndex() {
      this.$http.get('/api/category').then((res) => {
        this.cates = res.data.data
      })
    },
    /*-- 获取产品品牌 --*/
    brandIndex() {
      this.$http.get('/api/brand').then((res) => {
        this.brands = res.data.data
      })
    },
    /*-- 获取产品处方分类 --*/
    presclassIndex() {
      this.$http.get('/api/chuffl').then((res) => {
        this.presclass = res.data.data
      })
    },
    closed(type){
      //关闭选择采购单弹框
      console.log(this.form.goods)
      if(this.form.goods=='' && this.form.purchase==""){
        this.changeStatus = '无'
      }
    },
    delInfo(id){
      var _this = this
      this.form.noMatchProductList.forEach(function(rows,index){
        if(id==rows.id){
          _this.form.noMatchProductList.splice(index,1)
        }
      })
    },
    closeWin(){
      this.unmatchedCodeShow=false
      this.form.noMatchProductList = this.tempList
    },
    searchinfo(name){
      var list = []
      this.tempList = this.form.noMatchProductList
      if(this.form.noMatchProductList!=""){
        this.form.noMatchProductList.forEach(function(rows){
          if(rows.name==name || rows.recnumber==name){
            list.push(rows)
          }
        })
      }
      this.form.noMatchProductList = list
    },
    clearsInfo(){
      if(this.tempList!=''){
        this.form.noMatchProductList = this.tempList
      }
      
    },
    addInfo(item){
      var _this = this
      this.form.noMatchProductList.forEach(function(rows,index){
        if(item.id==rows.id){
          _this.form.noMatchProductList.splice(index,1)
        }
      })
      item.expected = Number(item.quantity)
      this.form.goods.push(item)
    },
    /*-- 产品初始化 --*/
    goodInit() {
      if (this.$route.params.sid == 'none') {
      } else {
        let url
        switch (this.$route.params.source) {
          case 'erp':
            url = '/api/inquiry/procurementPlanInfo'
            break
          case 'history':
            url = '/api/inquiry/myInquiryInfo'
            break
          case 'excel':
            url = '/api/excelInquiryInfo'
            break
        }
        this.$http.get(url, { params: { id: this.$route.params.sid } }).then((res) => {

          if (this.$route.params.source == 'erp') {
            for (let item of res.data.data) {
              this.$set(item.product, 'expected', item.expected)
              this.form.goods.push(item.product)
            }
          } else {
            res.data.data = res.data.data ? res.data.data : { pay: '', productList: [] }


            this.form.name = res.data.data.name
            this.form.cutoff.type = res.data.data.type
            
            this.form.cutoff.value = res.data.data.endValue
            this.form.aimType = res.data.data.aimType
            this.form.isTicket = res.data.data.isTicket
            this.form.contact = res.data.data.contact
            this.form.phone = res.data.data.phone
            this.form.pay = res.data.data.pay.value
            this.form.address = res.data.data.address
            this.form.remark = res.data.data.remark
            this.$forceUpdate()
            for (let item of res.data.data.productList) {
              this.$set(item.product, 'expected', item.expected)
              this.$set(item.product, 'enquiryName', item.enquiryName)
              this.$set(item.product, 'enquiryTicket', item.enquiryTicket)
              this.form.goods.push(item.product)
            }
            this.form.noMatchProductList = res.data.data.noMatchProductList
            this.tempList = res.data.data.noMatchProductList
          }
        })
      }
    },
    weiduima() {
      this.unmatchedCodeShow=true
      this.tempList = this.form.noMatchProductList
    },
    goodIndex(page) {
      this.changeStatus=false
      this.goodsDialogShow = true
      this.$http.get('/api/inquiry/product', {
        params: {
          userId: this.user.id,
          name: this.search.good.name,
          page: page,
          pageSize: 10
        }
      }).then((res) => {
        res.data.data = res.data.data ? res.data.data : []
        if (res.data.data.length == 0) {
          this.emptyText = '暂无数据'
        }
        this.goods = res.data.data
        for (let item of this.goods) {
          this.$set(item, 'expected', '')
        }
        this.goodTotal = res.data.total
      })
    },
    //选择采购单
    purchaseIndex(page){
       this.changeStatus=true//控制选择产品按钮不可点击
       this.purchaseDialogShow = true
       
       this.$http.get('/api/ucenter/pur/purOrder/list', {
        params: {
          userId: this.user.id,
          companyId:this.user.customerId,
          search: {status:10},
          page: page,
          pageSize: 10
        }
      }).then((res) => {
        res.data.data = res.data.data ? res.data.data : []
        if (res.data.data.length == 0) {
          this.emptyText = '暂无数据'
        }
        this.purchaseList = res.data.data
        for (let item of this.goods) {
          this.$set(item, 'expected', '')
        }
        this.purchaseTotal = res.data.total
      })

    },
    offerIndex(page) {
      this.offersDialogShow = true
      this.$http.get('/api/inquiry/supplier', {
        params: {
          userId: this.user.id,
          name: this.search.offer.name,
          page: page,
          pageSize: 10
        }
      }).then((res) => {
        this.offers = res.data.data
        this.offerTotal = res.data.total
      })
    },
    appendForm(field, item) {
      let len = this.form.goods.filter((itemer) => {
        return itemer.id == item.id
      }).length
      this.form[field].push(item)
    },
    //采购单
    appendForm1(field, item) {
      let len = this.form.purchase.filter((itemer) => {
        return itemer.pid == item.pid
      }).length
      this.form[field].push(item)
    },
    deleteForm(field, item) {
      let i = this.form[field].indexOf(item)
      this.form[field].splice(i, 1)
      if(this.form[field]==''){
        this.changeStatus = "无"
      }
    },
    uploadImage(param) {
      let formData = new FormData()
      formData.append('file', param.file)
      this.$http.post('/api/fileUpload', formData).then((res) => {
        if (res.data.success) {
          this.form.image.push(res.data.message)

        } else {
          this.$message.warning(res.data.message)
        }
      })
    },
    goodCreate(form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.$http.post('/api/ucenter/productAdd', this.form1).then((res) => {
            if (res.data.success) {
              this.$message.success(res.data.message)
              this.goodCreateVisable = false
              this.goodIndex()
            } else {
              this.$message.error(res.data.message)
            }
          })
        } else {
          return false
        }
      })
    },
    formatData(date1){
        var now = new Date(date1);
        var year = now.getFullYear(); //得到年份
        var month = now.getMonth();//得到月份
        var date = now.getDate();//得到日期
        var hour = now.getHours();//得到小时
        var minu = now.getMinutes();//得到分钟
        var sec = now.getSeconds();//得到秒
        month = month + 1;
        if (month < 10) month = "0" + month;
        if (date < 10) date = "0" + date;
        if (hour < 10) hour = "0" + hour;
        if (minu < 10) minu = "0" + minu;
        if(sec<10) sec = "0"+sec
        return year+'-'+month+'-'+date+" "+hour+":"+minu+":"+sec	
    },
    inquiryCreate(form) {
      var _this = this
      if(this.form.purchase=="" && this.form.goods == ""){
        this.$message.error('请选择产品或者采购单')
        return
      }
      if(this.form.noMatchProductList!='' && this.form.noMatchProductList!=undefined && this.form.noMatchProductList!=null){
        this.$confirm('您还有未对码的商品, 是否继续保存?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          _this.$refs[form].validate((valid) => {
            if (valid) {
              var ids = []
              if(_this.form.purchase!=''){
                _this.form.purchase.forEach(function(row){
                  ids.push(row.pid)
                })
                _this.form.purchaseIds = ids;
                _this.form.billType = 1
              }else{
                _this.form.billType = 0
              }
              _this.form.companyId = _this.user.customerId
              if(_this.form.cutoff.type == "deadline"){
                _this.form.cutoff.value = _this.formatData(_this.form.cutoff.value);
              }
             
              if (_this.expectedAble) {
                _this.submitAble = false
                _this.$http.post('/api/inquiry/save', _this.form).then((res) => {
                  if (res.data.success) {
                    _this.dialogResultVisible = true
                  } else {
                    _this.$alert(res.data.message, '操作提示', {
                      dangerouslyUseHTMLString: true
                    });
                  }
                  _this.submitAble = true
                })
              } else {
                _this.$refs[_this.errorExpected].focus()
                _this.$message.error('计划采购量不能为空')
              }
            } else {
              return false
            }
          })
        })
      }else{
        var ids = []
        if(this.form.purchase!=''){
          this.form.purchase.forEach(function(row){
            ids.push(row.pid)
          })
          this.form.purchaseIds = ids;
          this.form.billType = 1
        }else{
          this.form.billType = 0
        }
        this.form.companyId = this.user.customerId
        if(this.form.cutoff.type == "deadline"){
            this.form.cutoff.value = this.formatData(this.form.cutoff.value);
        }
        
        if (this.expectedAble) {
          this.submitAble = false
          this.$http.post('/api/inquiry/save', this.form).then((res) => {
            if (res.data.success) {
              this.dialogResultVisible = true
            } else {
              _this.$alert(res.data.message, '操作提示', {
                dangerouslyUseHTMLString: true
              });
              
            }
            this.submitAble = true
          })
        } else {
          this.$refs[_this.errorExpected].focus()
          this.$message.error('计划采购量不能为空')
        }
     
      }
      
    },
    refresher() {
      window.location.reload()
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/home/inquiry/create/index.js